// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"030cb9a0","250":"2a1dbf09","407":"4dcdff94","436":"99f0d263","453":"f394a27d","455":"2b9dbaca","501":"06b177a0","595":"053eafa3","606":"3b4ccc8f","691":"096811a4","821":"d5952224","880":"2ddedfbe","925":"528c1121","969":"5a64295a"}[chunkId] + ".chunk.js";
};